import { JSXElementConstructor, createContext } from 'react';
import { IFilterItemRendererProps } from './FilterBlock.interface';

export interface IFilterBlockContext {
  FilterBlockItemComponent?: JSXElementConstructor<IFilterItemRendererProps>;
}

export const FilterBlockContext = createContext<IFilterBlockContext>(undefined);
